<template lang="pug">
    v-card.overflow-y-auto(
        v-bind:style="{ height: sheetHeight + 'px' }"
        color="white"
        elevation="2"
        rounded
    )
        v-container
            v-tabs(grow show-arrows light v-model="currentTab")
                v-tab(v-for='item in tabItems' :key='item.key' :href='"#" + item.href')
                    | {{ item.name }}
                v-menu(v-if='tabMore.length > 0' bottom left)
                    template(v-slot:activator='{ on }')
                        v-btn.align-self-center.mr-4(text v-on='on')
                            | more
                            v-icon(right) mdi-menu-down
                    v-list.grey.lighten-5
                        v-list-item(v-for='item in tabMore' :key='item.key' @click='addTabItem(item)')
                            | {{ item.name }}

            v-tabs-items
                keep-alive
                    CallsWaiting(
                        v-if="currentTab === 'calls-waiting-tab'"
                        :calls-waiting="callsWaiting"
                        :live-dashboard-inbound-calls-enabled="liveDashboardInboundCallsEnabled"
                        :set-as-call-without-customer="setAsCallWithoutCustomer"
                        :set-current-call="setCurrentCall"
                        :set-current-campaign-customer="setCurrentCampaignCustomer"
                        :set-current-web-rtc-participant="setCurrentWebRtcParticipant"
                        :set-current-web-rtc-session="setCurrentWebRtcSession"
                        :set-supervisor-role="setSupervisorRole"
                    )

                    ResultsPhone(
                        v-else-if="currentTab === 'phone-tab'"
                        :current-day-dashboard-summary="currentDayDashboardSummary"
                        :hourly-dashboard-summaries="hourlyDashboardSummaries"
                        :team-scope-empty-message="teamScopeEmptyMessage"
                    )
</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import CallsWaiting from '@/components/dashboards/live/calls_waiting.vue';
    import ResultsPhone from '@/components/dashboards/live/results_phone.vue';

    export default Vue.extend({
        data() {
            return {
                containerHeight: null,
                currentTab: null,
                isLoading: false,
                isShowingAppointments: true,
                isShowingInbound: true,
                isShowingLeads: true,
                isShowingPhone: true,
                tabItems: [
                    { name: "Calls Waiting", key: "calls_waiting", href: "calls-waiting-tab" },
                ],
                tabMore: [
                    // { name: "Appointments", key: "appointments", href: "appointments-tab" },
                    // { name: "Leads", key: "leads", href: "leads-tab" },
                    { name: "Phone", key: "phone", href: "phone-tab" },
                ],
            }
        },
        methods: {
            addTabItem (item) {
                const removed = this.tabItems.splice(0, 1);
                this.tabItems.push(
                    ...this.tabMore.splice(this.tabMore.indexOf(item), 1)
                );
                this.tabMore.push(...removed);
                this.tabMore.sort((a, b) => {
                    if (a.name < b.name) {
                        return -1
                    }
                    if (a.name > b.name) {
                        return 1
                    }
                    return 0
                });

                this.currentTab = item.href;
            },
            handleWindowResize() {

                // Constants
                const paddingPx = 8;
                const toolbarHeight = 64;

                this.containerHeight = this.cardHeight - paddingPx - toolbarHeight;
            },
        },
        computed: {
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
        },
        components: {
            CallsWaiting,
            ResultsPhone,
        },
        props: {
            callsWaiting: Array,
            currentDayDashboardSummary: Object,
            hourlyDashboardSummaries: Array,
            liveDashboardInboundCallsEnabled: Boolean,
            sheetHeight: Number,
            setAsCallWithoutCustomer: Function,
            setCurrentCall: Function,
            setCurrentCampaignCustomer: Function,
            setCurrentWebRtcParticipant: Function,
            setCurrentWebRtcSession: Function,
            setSupervisorRole: Function,
            teamScopeEmptyMessage: String,
        },
        watch: {
            sheetHeight() {
                this.handleWindowResize();
            },
        },
        destroyed() {
        },
        created() {
        },
        mounted() {
        },
    });
</script>

<style lang="scss" scoped>
</style>
